import { omit } from 'lodash';
import { useHotel } from '../../../context/hotel-context';
import { useUser } from '../../../context/user-context';
import type { Meeting } from '../../../graphql/types';
import { today } from '../../../helpers/date-helpers';
import type { HandleSaveMeetingOptions } from '../context/meeting-context';
import * as Meetings from '../gql/_gen_/meeting.gql';

export const useSaveMeeting = (meeting?: Meeting, setMeeting?: (meeting: Meeting) => void) => {
  const { hotel } = useHotel();
  const { user } = useUser();

  const [saveMeeting, saveResults] = Meetings.useAddMeetingMutation({
    refetchQueries: [Meetings.namedOperations.Query.GetMeetingByDate],
  });
  const [updateMeeting, updateResults] = Meetings.useUpdateMeetingMutation();
  const handleSaveMeeting = async (options?: HandleSaveMeetingOptions) => {
    if (meeting?.id && meeting.brandCode === hotel?.brand_code) {
      return updateMeeting({
        variables: {
          updateMeetingId: meeting.id,
          ...omit(options, [
            'brandCode',
            'bucket',
            'bucketKey',
            'data',
            'meetingDate',
            'meetingTools',
            'reportDataFile',
          ]),
        },
        onCompleted: (data) => {
          if (data?.updateMeeting && setMeeting) {
            setMeeting(data.updateMeeting);
          }
        },
      });
    } else {
      return saveMeeting({
        variables: {
          brandCode: hotel?.brand_code,
          meetingDate: today(),
          createdById: user?.id as string,
          ...omit(options, ['bucket', 'bucketKey', 'data', 'meetingTools', 'reportDataFile']),
        },
        onCompleted: (data) => {
          if (data?.addMeeting && setMeeting) {
            setMeeting(data.addMeeting);
          }
        },
      });
    }
  };

  return { handleSaveMeeting, saveResults, updateResults };
};
